import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { shippingRatesTypes } from 'actions/types'

const initialState = []
const baseType = shippingRatesTypes.FETCH_SHIPPING_RATES

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
